import React from 'react';
import styles from './PropertyPremiumFacts.scss';
import { IProperty } from '../utils/JsonApiRequest';
import useUser from '../stores/useUser';
import HouseIcon from './svg/HouseIcon';
import PropertyRequest, { IPropertyStatistic } from '../utils/PropertyRequest';
import ButtonRound from './ButtonRound';
import { createModal } from '../utils/CreateModal';
import Config from '../utils/Config';
import SpeechBubble from './SpeechBubble';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import LockIcon from "../assets/img/icons/Lock.svg";
import Translate from '../utils/Translate';
import Button from './MaterialUi/Button';

const buyPremiumRoute = Config.get('buyPremiumRoute');

export interface IPropertyPremiumFactsProps {
    id: IProperty['drupal_internal__id'];
    uuid: IProperty['id'];
    ignorePremiumStatus?: boolean;
}

const ratings = [
    <>
        <AddCircleIcon />
        <AddCircleIcon />
        <span>Könnte klappen</span>
    </>,
    <>

        <AddCircleIcon />
        <span>Da geht was</span>
    </>,
    <>
        <RadioButtonUncheckedIcon />
        <span>Ganz okay</span>
    </>,
    <>
        <RemoveCircleIcon />
        <span>Du brauchst Glück</span>
    </>,
    <>
        <RemoveCircleIcon />
        <RemoveCircleIcon />
        <span>Nicht so gut</span>
    </>,
];

export const onlineSinceString = (created: string): string => {
    const onlineSinceHours =  created ? (Date.now() - new Date(created).valueOf()) / 3600 / 1000 : null;
    const onlineSinceDays =  created ? onlineSinceHours / 24 : null;

    return onlineSinceHours > 0 ? (
        onlineSinceDays >= 2 ? `${Math.floor(onlineSinceDays)}\u00A0Tagen` 
            : onlineSinceDays >= 1 ? `${Math.floor(onlineSinceDays)}\u00A0Tag`
                : Math.floor(onlineSinceHours) === 1 ? `${Math.floor(onlineSinceHours)}\u00A0Stunde`
                    : `${Math.floor(onlineSinceHours)}\u00A0Stunden`
    ) : (
        ''
    );
};

export const getChanceRating = (contactRequests: number): React.ReactElement => {
    const activeRating = Math.floor(Math.min(4, contactRequests / 5));
    return ratings[activeRating]
};

const PropertyPremiumFacts: React.FC<React.PropsWithChildren<IPropertyPremiumFactsProps>> = ({ uuid = null, id = null, ignorePremiumStatus }) => {
    const [user] = useUser();
    // const { width } = useWindowDimensions();
    const canShowFacts = user.isPremium || ignorePremiumStatus;

    const [data, setData] = React.useState<IPropertyStatistic>({
        pageview: null,
        contactRequests: null,
        created: null,
    });

    React.useEffect(() => {
        if (canShowFacts) {
            PropertyRequest.getStatistic(id).then((stat) => {
                setData(stat);
            });
        }
    }, [user]);


    const handleGetPremium = () => {
        if (user.isLoggedIn) {
            location.assign(`/user/${user.uid}/premium`);
        } else {
            createModal.createRegister((currUser) => {
                if (!currUser.is_premium) {
                    location.assign(`/user/${currUser.uid}/premium?destination=${window.location.pathname}`);
                }
            });
        }
    };

    const onlineSince = onlineSinceString(data.created);

    return <div className={styles.propertyPremiumFacts} onClick={canShowFacts ? undefined : handleGetPremium}>
        <h5>Chance-o-Meter</h5>
        <p>So stehen Deine Chancen auf diese Immobilie:</p>
        <div className={styles.premiumLabel}>
            Premium
        </div>

        <div className={styles.houseBubble}>
            <HouseIcon className={styles.house} />
            <SpeechBubble className={styles.bubble} />
            {canShowFacts
                ? <div className={styles.rating}>{getChanceRating(data.contactRequests)}</div>
                : <div className={styles.lock}><LockIcon  aria-hidden="true" /></div>
            }
        </div>

        <div className={styles.facts}>
            <dl>
                <dt>Online seit</dt>
                <dd title={Translate.getDate(data.created)}>
                    { onlineSince ? (
                        <>{onlineSince}</>
                    ) : (
                        <LockIcon  aria-hidden="true"/>
                    )}
                </dd>
            </dl>
            <dl>
                <dt>Angesehen</dt>
                <dd>{data.pageview !== null ? <>{data.pageview}&nbsp;Mal</> : <LockIcon  aria-hidden="true"/>}</dd>
            </dl>
            <dl>
                <dt>Angefragt</dt>
                <dd>{data.contactRequests !== null ? <>{data.contactRequests}&nbsp;Mal</> : <LockIcon  aria-hidden="true"/>}</dd>
            </dl>
        </div >

        {!canShowFacts && (
            <div className={styles.action}><Button onClick={handleGetPremium} size="large" variant="outlined" color="secondary">Mit Premium freischalten</Button></div>
        )}

    </div >
}

export default PropertyPremiumFacts;
